/**
 * Resolve the configured collector URL to an absolute one.
 *
 * OTEL_COLLECTOR_URL is deliberately a relative path (/otlp) so browser telemetry
 * stays same-origin and needs no CORS — nginx proxies it to the collector. But the
 * OTLP exporters validate their url with a bare `new URL(url)`, which throws
 * "Invalid URL" on a relative path because it has no base, and that throw would
 * escape initTelemetry() before the app renders.
 *
 * Resolving against window.location.origin keeps the same-origin proxy design while
 * giving the exporter the absolute URL it requires. An already-absolute value is
 * returned unchanged, so setting a full URL in the ConfigMap still works.
 */
export default function resolveCollectorUrl(collectorUrl) {
  return new URL(collectorUrl, window.location.origin).toString().replace(/\/$/, '');
}
